import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
// nodejs library that concatenates classes
import { yupResolver } from "@hookform/resolvers/yup";
import classnames from "classnames";
import { useForm } from "react-hook-form";
import { yupHelper } from "utilities/yupHelpers";
import * as yup from "yup";
// reactstrap components
import { Card, CardBody, Container, Form, FormGroup } from "reactstrap";

import { TitleContainer } from "@/components/HeaderContainer";
import { ThemedButton } from "@/components/ThemedButton";
import { resetUser } from "actions/auth";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { getErrorMessage } from "utilities/error";
import { removeLogUser } from "utilities/firebase";
import AuthService from "../../../../services/auth-api";

const schema = yup.object({
	otp: yupHelper.otp(),
});

function ProfileDeleteAccountOtpValidation() {
	const { user: userData } = useSelector((state) => state.auth);
	const [modalOpen, setmodalOpen] = React.useState(false);
	const currentUser = userData.user;
	// const { user: currentUser, isLoggedIn } = useSelector((state) => state.auth);
	const [loading, setLoading] = useState(false);
	const [otp, setotp] = useState("");
	const [message, setmessage] = useState("");
	const [seconds, setSeconds] = useState(30);
	const navigate = useNavigate();
	const dispatch = useDispatch();

	const {
		register,
		handleSubmit,
		formState: { errors },
	} = useForm({
		resolver: yupResolver(schema),
	});

	const handleOTP = (data) => {
		setLoading(true);

		let submit_otp = data.otp;
		// data.email = "manveeyew@firstcom.com.sg";
		AuthService.deleteAccountVerifyOtp(data)
			.then(
				() => {
					setLoading(false);

					removeLogUser();
					dispatch(resetUser());
					localStorage.removeItem("user");
					navigate("/login");
					toast.success("Deactivate Account Successfully!");
				},
				(error) => {
					setLoading(false);
					setmessage(getErrorMessage(error));
				},
			)
			.catch(() => {
				setLoading(false);
			});
	};

	const handleSendOTP = () => {
		if (!loading && seconds === 0) {
			setLoading(true);
			AuthService.forgetPasswordSendEmail(
				currentUser.learnermaster_email ? currentUser.learnermaster_email : "",
			)
				.then(
					() => {
						setSeconds(30);
						setLoading(false);
					},
					() => {
						setSeconds(30);
						setLoading(false);
					},
				)
				.catch(() => {
					setLoading(false);
				});
		}
	};

	useEffect(() => {
		if (seconds !== 0) {
			const interval = setInterval(() => {
				setSeconds(seconds - 1);
			}, 1000);
			return () => clearInterval(interval);
		}
	}, [seconds]);

	return (
		<>
			<Container fluid>
				<TitleContainer>{"Account Deletion OTP Verification"}</TitleContainer>

				<Card className='border-0 mx-auto mt-4' style={{ maxWidth: "600px" }}>
					<CardBody className='px-lg-5 py-lg-5 text-center'>
						<div className='pb-4'>
							<p>
								{"Please confirm if you would like to proceed with the account deletion request."}
							</p>
							<p className='mb-0'>Enter the OTP verification code that sent to</p>
							<p>
								<u className='text-lowercase'>{currentUser.learnermaster_email}</u>
							</p>
						</div>

						<Form role='form' onSubmit={handleSubmit(handleOTP)}>
							<FormGroup>
								<input
									className={"form-control " + (errors.otp ? "is-invalid" : "")}
									defaultValue=''
									placeholder='OTP Verification Code'
									type='text'
									{...register("otp")}
								/>
								<div className='mt-2 invalid-feedback text-center'>{errors.otp?.message}</div>
							</FormGroup>
							{/* <div className='mt-2 text-center'>
								Do not receive OTP Code?{" "}
								{seconds !== 0 && <span className='text-blue bold'>{seconds}</span>}
								{seconds === 0 && (
									<span disabled={loading} onClick={handleSendOTP} role='button' className='text-blue bold'>
										Resend
									</span>
								)}
							</div> */}
							<div className='justify-content-center mb-4 mt-2'>
								{/* <Button className='mt-2 w-100 btn-gradient' type='submit' disabled={loading}>
									{loading && <span className='spinner-border spinner-border-sm'></span>}
									<span>Continue</span>
								</Button> */}

								<ThemedButton type='submit' disabled={loading} w='100%'>
									{"Continue"}
								</ThemedButton>
							</div>

							{message && (
								<div className='form-group'>
									<div
										className={classnames(
											"alert",
											message === "OTP Sent Success" ? "alert-success" : "alert-danger",
										)}
										role='alert'>
										{message}
									</div>
								</div>
							)}
						</Form>
					</CardBody>
				</Card>
			</Container>
		</>
	);
}

export default ProfileDeleteAccountOtpValidation;
